import React from 'react';
import { useSelector } from 'react-redux';

import { NBSP } from '../../constants/symbols';
import { selectUser } from '../../selectors/user';
import { BenefitsCardList } from '../BenefitsCardList';
import { H2 } from '../H2';
import { RemoteFeaturesListItem } from '../RemoteFeaturesListItem';
import { Section } from '../Section';

import * as styles from './styles.css';

export const RemoteFeaturesSection: React.FC = () => {
  const isM2Enabled = useSelector(selectUser).isM2Enabled;

  return (
    <Section testId="remoteFeaturesSection">
      <H2 className={styles['h2']}>Сделка там, где удобно</H2>
      <BenefitsCardList>
        <RemoteFeaturesListItem
          title={`Дома или${NBSP}в${NBSP}любом удобном месте`}
          description="Проводите сделку там, где считаете нужным"
          imageX1="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/house_x1.png"
          imageX2="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/house_x2.png"
        />
        <RemoteFeaturesListItem
          title="Из любой точки мира"
          description="Если у всех участников есть загранпаспорт нового образца, организуем всё полностью удалённо"
          imageX1="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/globe_x1.png"
          imageX2="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/globe_x2.png"
        />
        {isM2Enabled && (
          <RemoteFeaturesListItem
            title="В офисе Банка ВТБ"
            description="Можно провести в офисах Банка ВТБ в более чем 200 городах РФ"
            imageX1="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/russia_x1.png"
            imageX2="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/russia_x2.png"
          />
        )}
      </BenefitsCardList>
    </Section>
  );
};
